import router from '../router'
router.beforeEach((to, from, next) => {
  // 页面跳转等判断
  if (to.path == '/login') {
      localStorage.setItem('route', JSON.stringify({
        path: from.path,
        query: from.query
      }))
  }
  next()
})



// WEBPACK FOOTER //
// ./src/axios/router.js